import s from "./Tag.module.scss";
import { PropsWithChildren, ReactNode } from "react";
import st from "@/styles/modules/typography.module.scss";
import cn from "classnames";
import { Link } from "@/components/shared/Link";

type TagProps = PropsWithChildren<{
  className?: string;
  link?: {
    href: string;
  };
}>;
export const Tag = ({ className, children, link }: TagProps) =>
  link ? (
    <Link href={link.href} className={cn(s.tag, st.link, className)}>
      {children}
    </Link>
  ) : (
    <span className={cn(s.tag, className)}>{children}</span>
  );
